import { PropsWithChildren } from 'react';
import classNames from 'classnames';

import * as S from './prompt-body.styles';

export type PromptBodyProps = {
  systemPrompt?: boolean;
  extended?: boolean;
};

export function PromptBody({ children, ...props }: PropsWithChildren<PromptBodyProps>) {
  const { systemPrompt, extended } = props;
  return (
    <S.PromptBody className={classNames({ 'system-prompt': systemPrompt, extended })}>
      {children}
    </S.PromptBody>
  );
}
